import { createSlice } from "@reduxjs/toolkit";
import { fetchUserCommunityData } from "../userManagementApi";

const fetchUserCommunityDataSlice = createSlice({
    name: "auth/fetchUserCommunityData",
    initialState: {
        data: {},
        loading: false,
        error: null,
        page: 1,
        pageSize: 10,
    },
    reducers: {
        setPage(state, action) {
        state.page = action.payload;
        },
        setPageSize(state, action) {
        state.pageSize = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // Handle fetchUserCommunityData cases
            .addCase(fetchUserCommunityData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserCommunityData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchUserCommunityData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { setPage, setPageSize } = fetchUserCommunityDataSlice.actions;
export default fetchUserCommunityDataSlice.reducer;
